import React, { useState } from 'react'
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateTimeFormatIOS } from 'pages/Common'


const StitchingStatusChangeWorkersEndTimeSetModel = ({ modal, toggle, HandWorkId, HandWorkOrderListApi }) => {
    const { postApi, putApi, getApi } = useApi()
    const [formButtonSumitLoading, setFormButtonSumitLoading] = useState(false)
    const [endTime, setEndTime] = useState(new Date());

    const handleSubmitEndDateTimeWorkers = () => {
        setFormButtonSumitLoading(true)
        postApi("HandWorkCosting/status-change", {
            Id: HandWorkId,
            Status: 4,
            InputEndDateTime: dateTimeFormatIOS(endTime),
        }).then(({ data, status }) => {
            setFormButtonSumitLoading(false)
            if (status == 200) {
                if (HandWorkOrderListApi != '') {
                    HandWorkOrderListApi()
                }
                toast.success("successfully updated", {
                    style: {
                        fontSize: "15px",
                    },
                })
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    return (
        <>
            <Modal
                isOpen={modal}
                toggle={toggle}
                centered={true}
                size="xl"
                style={{ width: !isMobile ? "300px" : "" }}
            >
                <div className="modal-content">
                    <ModalHeader toggle={toggle} tag="h5">
                        Set End Date Time
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row className=''>
                                <Col md={12}>
                                    <FormGroup className="mb-2">
                                        <Label
                                            htmlFor="validationCustom03"
                                            className="required"
                                        >
                                            End Date Time
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d-m-Y H:i",   // ✅ 24-hour format
                                                    time_24hr: true,           // ✅ ensures 24hr mode
                                                    disableMobile: true
                                                }}
                                                value={endTime}
                                                onChange={(e) => { setEndTime(e) }}
                                            />

                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-end">
                                {formButtonSumitLoading ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        color="secondary"
                                    >
                                        <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                        Loading
                                    </button>
                                ) : (
                                    <Button
                                        user="primary"
                                        className="btn btn-primary btn-sm "
                                        type="button"
                                        color="primary"
                                        onClick={() => handleSubmitEndDateTimeWorkers()}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </div>
                        </Form>
                    </ModalBody>
                </div>
            </Modal>
        </>
    )
}

export default StitchingStatusChangeWorkersEndTimeSetModel
